import { getFeedbackHighlightColor } from "helper/Helper";
import { FeedbackMessage } from "tasks/sample_feedback";

interface Props {
  setisActive(successfull: boolean): void;
  isActive: boolean;
  feedback: Array<FeedbackMessage>;
}

export const FeedbackModalCard = (props: Props) => {
  return (
    <div
      className="box"
      style={{
        position: "absolute",
        right: "20px",
        top: "20px",
        display: props.isActive ? "inline" : "none",
      }}
    >
      {props.feedback.map((element, id) => {
        const color = getFeedbackHighlightColor(element.valuation);
        return (
          <div key={id} style={{ color, marginBottom: "0.5rem" }}>
            <div>{element.category}</div>
            <div>{element.content}</div>
          </div>
        );
      })}
    </div>
  );
};
